const Colors = {
  white: '#ffffff',
  black: '#000000',
  background: '#2c3035'
};

export default Colors;
